import { z } from 'zod';

// Creates a Zod schema that transforms unexpected enum values to a fallback value
export const createSafeEnum = <T extends z.ZodEnum<any>>(
  enumSchema: T,
  fallbackValue: z.infer<T>
) => {
  type EnumType = z.infer<T>;
  return z.string().transform((val: string) => {
    return enumSchema.options.includes(val as EnumType) ? val : fallbackValue;
  }) as z.ZodType<EnumType>;
};
